// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons } from '../components';

export default function LoginGradient() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <AuthLayoutWrapper
      variant="gradient"
      glassEffect
      gradientFrom="#667eea"
      gradientTo="#764ba2"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/login"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Logo/Brand */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
              }}
            >
              <Text size="xl" fw={700} c="white">G</Text>
            </Center>
            <Title order={2} ta="center">Welcome back</Title>
            <Text c="dimmed" size="sm" ta="center">
              Sign in with your credentials
            </Text>
          </Stack>
        </Center>

        {/* Social Login First */}
        <SocialLoginButtons
          providers={['google', 'apple', 'github']}
          layout="vertical"
          showDivider={false}
        />

        {/* Divider */}
        <Group gap="xs" justify="center">
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
          <Text size="xs" c="dimmed">or sign in with email</Text>
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
        </Group>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Group justify="space-between">
              <Checkbox
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.currentTarget.checked)}
              />
              <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/gradient" size="sm">
                Forgot password?
              </Anchor>
            </Group>

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: '#667eea', to: '#764ba2' }}
            >
              Sign in
            </Button>
          </Stack>
        </form>

        {/* Register Link */}
        <Text ta="center" size="sm">
          Don't have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/register/gradient" fw={500}>
            Create one now
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
